var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "p-3 pl-4"
  }, _vm._l(_vm.logs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "vertical-line"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "pl-3 content-log"
    }, [_c('div', {
      staticClass: "d-flex align-items-center mb-1 text-blue-400"
    }, [_c('i', {
      class: ['fa', 'mr-2', _vm.method == 'COUNTER' ? 'fa-clock-o' : 'fa-calendar-alt'],
      staticStyle: {
        "font-size": "18px"
      }
    }), _c('p', {
      staticClass: "text-sm mb-0",
      staticStyle: {
        "font-weight": "500"
      }
    }, [_vm.method == 'COUNTER' ? [_vm._v(" " + _vm._s(_vm.formatNumber(item === null || item === void 0 ? void 0 : item.extra_hours)) + " Hours ")] : [_vm._v(" " + _vm._s(item !== null && item !== void 0 && item.extra_date ? _vm.moment(item === null || item === void 0 ? void 0 : item.extra_date).format('DD/MM/YYYY') : '-') + " ")]], 2)]), _c('small', {
      staticClass: "text-black"
    }, [_vm._v(_vm._s(item.reason))])])]);
  }), 0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "circle"
  }, [_c('div', {
    staticClass: "dot"
  })]);

}]

export { render, staticRenderFns }